import React, { useState, useEffect } from "react";
import { CiTimer } from "react-icons/ci";
import userimage from "./assets/img/userimage.png";
import axios from "axios";
import {
  IoIosArrowDropleftCircle,
  IoIosArrowDroprightCircle,
} from "react-icons/io";

export default function Leftside({ ActiveUserData, Activemultiplier, roundStatusDummyActive }) {
  const [activetab, SetActivetab] = useState("Tab1");
  const [myBetData, setmyBetData] = useState(null);
  const [AllBet, setAllBet] = useState(0);
  const [myBetDataAciveRound, setmyBetDataAciveRound] = useState(null);
  const [TopBetData, setTopBetData] = useState(null);
  const [dummyBattles, setlistDummyBattles] = useState(null);
  const itemsPerPage = 10; // Number of items per page
  const [currentPage, setCurrentPage] = useState(1);
  const roundId = localStorage.getItem("roundId")
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  // Handle page change
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleTabClick = (tab) => {
    SetActivetab(tab);
    profileDataLoad();
    ActiveprofileDataLoad();
    profileDataLoad1();
  };

  // Fetch user bets data
  useEffect(() => {
    profileDataLoad();
    ActiveprofileDataLoad();
    profileDataLoad1();


  }, []);
  useEffect(() => {

    ActiveprofileDataLoad();
    listDummyBattles();
    profileDataLoad();
  }, [ActiveUserData]);

  const profileDataLoad = async () => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("_id");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/bets/myBet`,
        { userId, role },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // Filter bets where gameRoundId is not equal to roundId
      const filteredBets = (response.data.userBets || []).filter(
        (bet) => (bet.gameRoundId != roundId && bet.betStatus === "active") || bet.betStatus === "cashed out"
      );


      setmyBetData(filteredBets);

    } catch (err) {
      console.error("Error fetching profile data:", err);
    }
  };
  const ActiveprofileDataLoad = async () => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("_id");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/bets/AllActiveBet`,
        { userId, role },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const filteredBetsAciveRound = (response.data.usersWithBets || []).filter(
        (bet) => (bet.gameRoundId == roundId || (bet.betStatus === "active" && bet.betStatus === "cashed out"))
      );

      setmyBetDataAciveRound(response.data.usersWithBets);
      const AllBet = response.data.usersWithBets.length();
      setAllBet(AllBet)
    } catch (err) {
      console.error("Error fetching profile data:", err);
    }
  };
  // Calculate total pages
  const totalPages = myBetData ? Math.ceil(myBetData.length / itemsPerPage) : 1;

  // Get data for the current page
  const paginatedData = myBetData
    ? myBetData.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    )
    : [];

  const profileDataLoad1 = async () => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("_id");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/bets/topWinners`,
        { userId, role },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setTopBetData(response.data.topWinners || []); // Ensure `userBets` is an array
    } catch (err) {
      console.error("Error fetching profile data:", err);
    }
  };
  const listDummyBattles = async () => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("_id");
    try {
      const response = await axios.post('https://aviatornode.a2logicgroup.com/api/bets/UserlistDummyBattles',
        { userId, role },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.warn("response.data", response.data.data)

      const data = response.data.data;

      const getRandomItems = () => {
        const shuffled = data.sort(() => 0.5 - Math.random());
        return shuffled.slice(0, 15);
      };

      // Use setInterval to update the list every 200 milliseconds
      const intervalId = setInterval(() => {
        const randomThree = getRandomItems();
        setlistDummyBattles(randomThree);
      }, 4000);
const AllBets = Math.floor(Math.random() * (100000 - 5000 + 1)) + 5000
   setAllBet(AllBets)
      setTimeout(() => {
        clearInterval(intervalId);
      }, 5000);



    } catch (err) {
      console.error("Error fetching profile data:", err);
    }
  };

  const getBetStatusClass = (betStatus, gameRoundId, roundId) => {

    if (betStatus === "active" && gameRoundId !== roundId) return "loss";
    return "win";
  };

  const formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(2) + "m";
    } else if (num >= 1000) {
      return (num / 1000).toFixed(2) + "k";
    }
    return num.toFixed(2);
  };

  const getColorClass = (price) => {
    if (price < 2) return "red";
    if (price >= 2 && price < 5) return "orange";
    if (price >= 5 && price < 10) return "green";
    return "blue";
  };
  return (
    <div id="leftside">
      <div className="leftsidebar">
        <div className="tabsdesign">
          <div
            className={
              activetab === "Tab1" ? "active tabs_links" : "tabs_links"
            }
            onClick={() => handleTabClick("Tab1")}
          >
            All Bets
          </div>
          <div
            className={
              activetab === "Tab2" ? "active tabs_links" : "tabs_links"
            }
            onClick={() => handleTabClick("Tab2")}
          >
            My Bets
          </div>
          <div
            className={
              activetab === "Tab3" ? "active tabs_links" : "tabs_links"
            }
            onClick={() => handleTabClick("Tab3")}
          >
            Top
          </div>
        </div>
        {activetab === "Tab1" && (
          <div className="tab-content">
            <div className="d-flex justify-content-between align-items-center allbetscount">
            <div className="allbets">
  All Bets {"  "}
 <span>{(Activemultiplier || roundStatusDummyActive == 'active' || roundStatusDummyActive == 'crashed') && (AllBet) 
         }</span> 
</div>

              <div className="previoushand d-flex gap-2 align-items-center">
                <CiTimer /> Preivous Hand
              </div>
            </div>
            <div className="border_custum"></div>
            <div className="table bettingtable">
              <div className="tableheading">
                <div className="d-flex justify-content-between gap-10 mb-2 header">
                  <h6 className="mb-0 pb-0">User</h6>
                  <h6 className="mb-0 pb-0">Bet ₹ X</h6>
                  <h6 className="mb-0 pb-0">Cash Out ₹</h6>
                </div>
                {/* {ActiveUserData &&
                  ActiveUserData.length > 0 &&
                  ActiveUserData.map((user) => ( */}
                <div className="user_table">
                  {myBetDataAciveRound &&
                    myBetDataAciveRound.length > 0 &&
                    myBetDataAciveRound
                      .filter((user) =>
                        user.bets &&
                        (user.bets.gameRoundId === roundId &&
                          (user.bets.betStatus === "active" || user.bets.betStatus === "cashed out"))
                      )
                      .map((user) => (
                        <div
                          key={user.userId}
                          className={`d-flex justify-content-start ${(Activemultiplier && user.bets.cashOutMultiplier !== null && user.bets.cashOutMultiplier !== undefined ) ? "win" : "loss"}  gap-10 userdetails`}
                        >
                          <div className="mb-0 pb-0 d-flex align-items-center gap-2 innerdetails">
                            <div className="userimage">
                              <img src={`https://aviatornode.a2logicgroup.com${user.bets.ProfileImage}`} />
                            </div>
                            <span>
                              {user.bets.Name.charAt(0)}***
                              {user.bets.Name.charAt(user.bets.Name.length - 1)}
                            </span>
                          </div>
                          <h3 className="mb-0 pb-0 fs-1">
                            {user.bets.betAmount !== null && user.bets.betAmount !== undefined && (
                              formatNumber(user.bets.betAmount)
                            )}
                            {user.bets.cashOutMultiplier !== null && user.bets.cashOutMultiplier !== undefined && (
                              <span  className={`${getColorClass(user.bets.cashOutMultiplier)}`}> {formatNumber(user.bets.cashOutMultiplier)}x </span>
                            )}
                          </h3>

                          <h3 className="mb-0 pb-0 fs-1">
                            {formatNumber(user.bets.winnings)}
                          </h3>
                        </div>
                      ))}

                  {dummyBattles && dummyBattles.length > 0 ? (
                    dummyBattles.map((dummy) => (
                      <>

                        {(Activemultiplier || roundStatusDummyActive == 'active' || roundStatusDummyActive == 'crashed') &&
                          <div className={`d-flex justify-content-start gap-10 userdetails ${(Activemultiplier >= dummy.price) ? "win" : "loss"} `} key={dummy.id} >
                            <div className="mb-0 pb-0 d-flex align-items-center gap-2 innerdetails">
                              <div className="userimage">
                                <img src={`https://aviatornode.a2logicgroup.com/${dummy.createrImage}`} />
                              </div>
                              <span>  {dummy.createrName.charAt(0)}***
                                {dummy.createrName.charAt(dummy.createrName.length - 1)}</span>
                            </div>
                            <h3 className="mb-0 pb-0 fs-1">
                              {formatNumber(dummy.amount)} <span className={`${getColorClass(dummy.price)}`}>{Activemultiplier && Activemultiplier >= dummy.price
                                ? `${dummy.price}x`
                                : " "}</span>
                            </h3>

                            <h3 className="mb-0 pb-0 fs-1">     {Activemultiplier && dummy.price <= Activemultiplier ? formatNumber(dummy.price * dummy.amount) : null}
                            </h3>
                          </div>
                        }
                      </>
                    ))
                  ) : (
                    <></>
                  )}

                </div>
              </div>
            </div>
          </div>
        )}
        {activetab === "Tab2" && (
          <div className="tab-content">
            <div class="d-flex justify-content-between align-items-center allbetscount"><div class="allbets"></div>
              <div class="previoushand d-flex gap-2 align-items-center border-dark"></div></div>
            <div className="table bettingtable">
              <div className="tableheading">
                <div className="d-flex justify-content-between gap-10 mb-2 header">
                  <h6 className="mb-0 pb-0">User</h6>
                  <h6 className="mb-0 pb-0">Bet ₹ X</h6>
                  <h6 className="mb-0 pb-0">Cash Out ₹</h6>
                </div>
                <div className="user_table">
                  {myBetData &&
                    [...myBetData].reverse().map((user) => (
                      <div
                        className={`d-flex justify-content-start gap-10 userdetails ${getBetStatusClass(
                          user.betStatus,
                          user.gameRoundId,
                          roundId
                        )}`}
                      >

                        <div className="mb-0 pb-0 d-flex align-items-center gap-2 innerdetails">
                          {/* <div className="userimage">
                          <img src={userimage} />
                        </div> */}
                          {user.betStatus == "active" && user.gameRoundId != roundId ?

                            // <span >Active </span>
                            // :user.betStatus == "canceled"  ? 
                            // <span >CANCELED</span>
                            //  :user.betStatus == "active" && user.gameRoundId !=roundId ?

                            <span>LOSS</span>
                            :

                            <span>WIN</span>
                          }
                        </div>
                        <h3 className="mb-0 pb-0 fs-1">
                          {user.betAmount}{" "}
                          {user.cashOutMultiplier > 0 && (
                            <span>{user.cashOutMultiplier.toFixed(2)}</span>
                          )}
                        </h3>
                        <h3 className="mb-0 pb-0 fs-1">
                          {user.winnings.toFixed(2)}
                        </h3>
                      </div>
                    ))}
                </div>
              </div>
              {/* {myBetData && myBetData.length > 0 ?
                <div className="pagination-controls">
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    <IoIosArrowDropleftCircle />
                  </button>
                  <span>{currentPage}</span>
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    <IoIosArrowDroprightCircle />
                  </button>
                </div>
                :
                <div className="pagination-controls">
                  <p>No Bets</p>
                </div>
              } */}
            </div>
          </div>
        )}
        {activetab === "Tab3" && (
          <div className="tab-content">
            <div className="d-flex justify-content-between align-items-center allbetscount">
              <div className="allbets">All Bet {myBetDataAciveRound && myBetDataAciveRound.length > 0
                ? myBetDataAciveRound.filter(
                  (user) =>
                    user.bets &&
                    user.bets.gameRoundId === roundId &&
                    (user.bets.betStatus === "active" || user.bets.betStatus === "cashed out")
                ).length
                : 0}</div>
              <div className="previoushand d-flex gap-2 align-items-center">
                <CiTimer /> Preivous Hand
              </div>
            </div>
            <div className="border_custum"></div>
            <div className="table bettingtable">
              <div className="tableheading">
                <div className="d-flex justify-content-between gap-10 mb-2 header">
                  <h6 className="mb-0 pb-0">User</h6>
                  <h6 className="mb-0 pb-0">Total Win</h6>
                  <h6 className="mb-0 pb-0">Total Bets</h6>
                </div>
                <div className="user_table">
                  {TopBetData &&
                    TopBetData.map((user) => (
                      <div className="d-flex justify-content-start gap-10 userdetails win">
                        <div className="mb-0 pb-0 d-flex align-items-center gap-2 innerdetails">
                          <div className="userimage">
                            <img src={`https://aviatornode.a2logicgroup.com${user.ProfileImage}`} />
                          </div>
                          <span>
                            {user.Name.charAt(0)}***
                            {user.Name.charAt(user.Name.length - 1)}
                          </span>
                        </div>
                        {user.totalWinnings &&
                          <h3 className="mb-0 pb-0 fs-1">

                            {user.totalWinnings.toFixed(2)}
                          </h3>}
                        <h3 className="mb-0 pb-0 fs-1 mx-1">{user.totalBets} </h3>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
